// @givmo/app-charity — the ONE request dialog's door, reachable from every surface (shell contract
// v3, T5.1).
//
// The request dialog is mounted ONCE, in the shell, and the popup's tiles, the sidebar's request rows
// and a module's direct-link gate all open the SAME one — a deep link and a tile must agree, and
// three dialogs would be three places for the copy and the tier rule to drift. The pages reach it
// through this context rather than through props threaded down the route tree.

import { createContext, use } from 'react';

export interface RequestAccessDoor {
  /** Open the dialog for a module this person does not hold — Member pre-set, Owner offered. */
  open: (module: string) => void;
}

export const RequestAccessContext = createContext<RequestAccessDoor | null>(null);

/** The door, or a no-op outside the shell (a page rendered in a harness without one). */
export function useRequestAccessDoor(): RequestAccessDoor {
  return use(RequestAccessContext) ?? { open: () => undefined };
}
